import Counter from '@/views/B2BCheckout/components/Counter';
import { MAX_LICENSES } from '@/views/B2BCheckout/constants';
import { ACTIONS } from '@/views/B2BCheckout/context/types';
import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

const LicenceCounter = () => {
  const {
    dispatch,
    state: { licences, currentStep },
  } = useCheckoutCtx();

  const setCount = (count: number) => {
    dispatch({
      type: ACTIONS.SET_LICENCE_NUMBER,
      payload: count,
    });
  };

  return (
    <div className="bg-white border-l-4 border-solid border-primary-main rounded-5 p-24 items-center justify-between mb-12 shadow-dropdown w-full flex">
      <p className="font-label">Número de licencias</p>
      <Counter
        count={licences}
        setCount={setCount}
        maxCount={MAX_LICENSES}
        disabled={currentStep === 3}
      />
    </div>
  );
};

export default LicenceCounter;
